module.exports = __webpack_public_path__ + "static/media/back_circle.591470f6.svg";